export const renderSelectedFilter = (title: string, id: string) => {
  const selectedFilter = document.createElement("div")

  selectedFilter.classList.add("i-selected-filter", "d-inline-flex", "gap-1", "u-fz-14", "u-fw-500")
  selectedFilter.dataset.id = id

  const inner = `
    <span class="i-selected-filter__title">
      ${title}
    </span>
    <span class="i-selected-filter__remove d-flex align-items-center justify-content-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="15.994" height="16" viewBox="0 0 15.994 16">
        <path d="M17232.215,18376.3l6.08,6.074,6.074-6.074,1.92,1.92-6.074,6.08,6.074,6.074-1.92,1.926-6.074-6.08-6.08,6.08-1.92-1.926,6.074-6.074-6.074-6.08Z" transform="translate(-17230.295 -18376.299)" fill="#292934" />
      </svg>
    </span>
  `


  selectedFilter.innerHTML = inner

  selectedFilter.addEventListener("click", () => {
    const id = `#${selectedFilter.dataset.id ?? ""}`

    selectedFilter.remove()

    const checkbox = document.querySelector<HTMLInputElement>(id)

    if (!checkbox) return

    checkbox.checked = false
    checkbox.dispatchEvent(new Event('change'))

  })

  return selectedFilter
}
